var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useCallback } from 'react';
import { css, styled } from 'styled-components';
import { Help } from '@hn-ui/icons';
import { StuckStudentsTable } from './StuckStudentsTable';
import { ShowAllButton } from './ShowAll';
import { useToggle } from '@hn-front/utils';
import { useWeeklyDashboardAnalytics, WeeklyDashboardEvents, } from '../../hooks/useWeeklyDashboardAnalytics';
import { useStuckStudents } from '../../hooks/useStuckStudents';
import { StuckTooltip } from './Tooltip';
import { WeeklyReportZIndex } from '../../constants/styles';
var Container = styled.section.withConfig({ displayName: "Container", componentId: "sc-smxab1" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  padding: 24px 32px;\n  flex-direction: column;\n  gap: 24px;\n  border-radius: 0px 16px 16px 0px;\n  border-left: 8px solid ", ";\n  background: #fff;\n  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.07);\n\n  ", ";\n"], ["\n  display: flex;\n  padding: 24px 32px;\n  flex-direction: column;\n  gap: 24px;\n  border-radius: 0px 16px 16px 0px;\n  border-left: 8px solid ", ";\n  background: #fff;\n  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.07);\n\n  ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.red50;
}, function (_a) {
    var $popupShowed = _a.$popupShowed;
    return $popupShowed && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      position: relative;\n      z-index: ", ";\n    "], ["\n      position: relative;\n      z-index: ", ";\n    "])), WeeklyReportZIndex.STUCK_STUDENTS);
});
var Title = styled.h2.withConfig({ displayName: "Title", componentId: "sc-1xzpakm" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  color: ", ";\n  font-family: 'Noto Sans', sans-serif;\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 24px;\n  margin: 0;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  color: ", ";\n  font-family: 'Noto Sans', sans-serif;\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 24px;\n  margin: 0;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black50;
});
var Overlay = styled.div.withConfig({ displayName: "Overlay", componentId: "sc-1a69m7r" })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  &::before {\n    content: '';\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.3);\n    z-index: ", ";\n    width: 100vw;\n    height: 100vh;\n  }\n"], ["\n  &::before {\n    content: '';\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.3);\n    z-index: ", ";\n    width: 100vw;\n    height: 100vh;\n  }\n"])), WeeklyReportZIndex.STUCK_OVERLAY);
var maxPerPage = 2;
var StuckStudents = function (_a) {
    var stuckStudents = _a.stuckStudents, popupSeen = _a.popupSeen, rest = __rest(_a, ["stuckStudents", "popupSeen"]);
    var _b = useStuckStudents({
        stuckStudents: stuckStudents,
        stuckStudentsPopupSeen: popupSeen,
    }), showStuckStudents = _b.showStuckStudents, showStuckPopup = _b.showStuckPopup, toggleStuckPopup = _b.toggleStuckPopup, refStuckContainer = _b.refStuckContainer, refStuckPopup = _b.refStuckPopup;
    if (!showStuckStudents)
        return null;
    return (_jsxs(_Fragment, { children: [showStuckPopup && _jsx(Overlay, { "data-testid": 'stuck-students-overlay' }, void 0), _jsx(StuckTooltip, __assign({ tooltipProps: {
                    ref: refStuckPopup,
                    visible: showStuckPopup,
                    interactive: showStuckPopup,
                    placement: 'top-start',
                    maxWidth: '100%',
                }, onLinkClick: function () { return toggleStuckPopup(false); } }, { children: _jsx(StuckStudentsContainer, __assign({}, rest, { data: stuckStudents, popupShowed: showStuckPopup, ref: refStuckContainer, "data-testid": 'stuck-students' }), void 0) }), void 0)] }, void 0));
};
var StuckStudentsContainer = forwardRef(function (_a, ref) {
    var data = _a.data, popupShowed = _a.popupShowed, rest = __rest(_a, ["data", "popupShowed"]);
    var _b = useToggle(), isToggled = _b.isToggled, toggle = _b.toggle;
    var currentStudents = isToggled ? data : data.slice(0, maxPerPage);
    var showShowAllButton = data.length > maxPerPage;
    var sendEvent = useWeeklyDashboardAnalytics();
    var handleShowAllClick = useCallback(function () {
        toggle();
        sendEvent(isToggled
            ? WeeklyDashboardEvents.stuckShowLessClick
            : WeeklyDashboardEvents.stuckShowAllClick);
    }, [isToggled, toggle, sendEvent]);
    return (_jsxs(Container, __assign({ ref: ref, "$popupShowed": popupShowed }, rest, { children: [_jsxs(Title, { children: ["Stuck Students", _jsx(StuckTooltip, __assign({ onLinkClick: function () {
                            return sendEvent(WeeklyDashboardEvents.stuckTooltipLinkClick);
                        } }, { children: _jsx(Help, { role: 'img', "aria-label": 'Help', color: 'black70', onMouseEnter: function () {
                                return sendEvent(WeeklyDashboardEvents.stuckHelpIconHover);
                            } }, void 0) }), void 0)] }, void 0), _jsx(StuckStudentsTable, { data: currentStudents }, void 0), showShowAllButton && (_jsx(ShowAllButton, { studentCount: data.length, onClick: handleShowAllClick, toggled: isToggled }, void 0))] }), void 0));
});
export { StuckStudents };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
